// test355
(355 && 0);
